var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolonezShipmentsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1182B",
    fillRule: "evenodd",
    d: "M10 18.333c-3.536 0-5.303 0-6.402-1.22C2.5 15.893 2.5 13.928 2.5 10s0-5.893 1.098-7.113c1.099-1.22 2.866-1.22 6.402-1.22s5.303 0 6.402 1.22C17.5 4.107 17.5 6.072 17.5 10s0 5.893-1.098 7.113c-1.099 1.22-2.867 1.22-6.402 1.22M12.5 5h-5c-.387 0-.581 0-.74.043a1.25 1.25 0 0 0-.884.883c-.043.16-.043.353-.043.74 0 .388 0 .582.043.74.116.432.452.77.884.885.159.042.353.042.74.042h5c.387 0 .581 0 .74-.042a1.25 1.25 0 0 0 .884-.884c.043-.16.043-.353.043-.74 0-.388 0-.582-.043-.74a1.25 1.25 0 0 0-.884-.884C13.081 5 12.887 5 12.5 5m-5 5.833a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0m2.5.834A.833.833 0 1 0 10 10a.833.833 0 0 0 0 1.667m4.167-.834a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0M13.333 15a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667m-2.5-.833a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0M6.667 15a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolonezShipmentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polonez-shipments-icon.53275e350c255658f471a2fc09d6bc12.svg";